import CircularProgress from 'src/components/atoms/circular-progress/CircularProgress';
import DailyHabitsIcon from 'src/components/molecules/daily-habits-icon/DailyHabitsIcon';
import { INavigationTabsItem } from 'src/components/molecules/navigation-tabs/NavigationTabs';
import PlanHabitDetails from 'src/components/organisms/plan-habit-details/PlanHabitDetails';
import { DailyHabitPlanState } from 'src/utils/enums';
import DailyHabitsInterstitialMessage from 'src/components/organisms/daily-habits-interstitial-message/DailyHabitsInterstitialMessage';
import { DailyHabitPlan } from 'src/models/dailyHabit/DailyHabitPlan';
import { useStore } from './useStore';

export const useDailyHabitsTabs = (): INavigationTabsItem[] => {
  const { dailyHabitsStore, homeWidgetTextStore } = useStore();
  const userPlans = dailyHabitsStore.dailyHabits?.userPlans ?? [];
  const renderPlanComponent = (plan: DailyHabitPlan, name: string): React.ReactNode => {
    switch (plan.state) {
      case DailyHabitPlanState.InProgress:
        return <PlanHabitDetails plan={plan} name={name} />;
      case DailyHabitPlanState.Completed:
        return <DailyHabitsInterstitialMessage completedPlanNames={[name]} failedPlanNames={[]} />;
      case DailyHabitPlanState.Failed:
        return <DailyHabitsInterstitialMessage completedPlanNames={[]} failedPlanNames={[name]} />;
    }
  };

  return userPlans.map((plan) => {
    const name = homeWidgetTextStore.getHomeWidgetText(`Goals:${plan.textKey || plan.id}:Name`) || 'Unnamed Plan';
    return ({
      name,
      value: plan.id,
      icon: (
        <CircularProgress progress={plan.overallProgressPct ?? 0}>
          <DailyHabitsIcon planId={plan.id} />
        </CircularProgress>
      ),
      component: () => renderPlanComponent(plan, name),
    });
  });
};
